import { v4 as uuidv4 } from 'uuid';

const storageKey = 'ajs_anonymous_id';
const writeToStorage = uuid =>
  localStorage.setItem(storageKey, JSON.stringify(uuid));
const readFromStorage = () => JSON.parse(localStorage.getItem(storageKey));

const getUserAnonymousId = () => {
  const hasUserConsentToAnalytics =
    window.WM && window.WM.UserConsent.getUserConsentAdvertisingState();

  if (window.analytics && window.analytics.user && hasUserConsentToAnalytics) {
    return window.analytics.user().anonymousId();
  }

  let anonymousId = '';

  try {
    anonymousId = readFromStorage() || uuidv4();
    writeToStorage(anonymousId);
  } catch (e) {
    anonymousId = uuidv4();
  }

  return anonymousId;
};

export default getUserAnonymousId;
